


































































































































































































import BackLink from "@/components/app/BackLink.vue";
import { CatalogVue } from "fs-pb-vue2/vueModels/catalog/CatalogVue";
import CatalogIcon from "@/components/catalog/CatalogIcon.vue";
import SearchInput from "fs-pb-vue2/components/SearchInput.vue";
import Transfers from "@/components/catalog/Transfers.vue";
import ChoosenPayments from "@/components/catalog/ChoosenPayments.vue";
import Preloader from "@/components/app/Preloader.vue";
import MainNavigation from "@/components/navigation/MainNavigation.vue";
import { Watch, Component } from "vue-property-decorator";
import { CatalogData } from "fs-pb-vue2/data";

@Component({
  components: { CatalogIcon, SearchInput, BackLink, Transfers, ChoosenPayments, Preloader, MainNavigation }
})
export default class Catalog extends CatalogVue {
  async mounted(): Promise<void> {
    await this.getCharges();
  }

  catalogQuery: string = '';

  showTransfersCatalog: boolean = false;

  @Watch('$route.query', { immediate: true })
  async queryChanged(val: any): Promise<void> {
    if (val && val.query) {
      this.searchActive = true;
      await this.catalogStore.fetchCatalog(0);
      await this.searchCatalog({ query: val.query });
      this.catalogQuery = val.query;
    } else if (this.searchActive) {
      this.searchActive = false;
      await this.clearCatalog();
    }
  }

  async beforeDestroy(): Promise<void> {
    if (this.searchActive) {
      this.searchActive = false;
      await this.clearCatalog();
    }
  }

  get paymentsCatalog(): CatalogData {
    return this.catalogStore.catalog.Childrens.find((cat: CatalogData) => cat.Caption === 'Платежи');
  }

  get transfersCatalog(): CatalogData {
    return this.catalogStore.catalog.Childrens.find((cat: CatalogData) => cat.Caption === 'Переводы');
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  get limitedChildrens(): CatalogData[] {
  if (this.windowWidthCalc < 426 ) {
    return this.transfersCatalog.Childrens.slice(0, 7);
  }
  return this.transfersCatalog.Childrens;
}

  back(): void {
    if (this.selectedCatalog) {
      if (this.parentCatalog.length === 1) {
        this.selectedCatalog = null;
        this.parentCatalog = [];
      } else if (this.parentCatalog.length > 1) {
        this.selectedCatalog = this.parentCatalog[
          this.parentCatalog.length - 1
        ][0];
        this.parentCatalog.pop();        
      }
    }
  }
}
